import type {IssueTypePickerIssueType} from '@github-ui/item-picker-issue-type'
import type {RecordSourceProxy} from 'relay-runtime'

/**
 * Updates issue type for multiple issues in the Relay store
 * @param store - The Relay RecordSourceProxy to update
 * @param ids - Array of issue IDs to update
 * @param issueTypeId - The new issue type ID, or null/undefined to unset
 */
export function updateIssueIssueTypeById(
  store: RecordSourceProxy,
  ids: string[],
  issueTypeId: string | null | undefined,
) {
  for (const id of ids) {
    const issue = store.get(id)
    if (!issue) return

    // Remove the issue type if the issue type is null (unset)
    const issueType = issueTypeId ? store.get(issueTypeId) : null
    if (!issueType) {
      issue.setValue(null, 'issueType')
      continue
    }

    issue.setLinkedRecord(issueType, 'issueType')
  }
}

/**
 * Adds an issue type to the Relay store for optimistic updates
 * @param store - The Relay RecordSourceProxy to update
 * @param issueTypeId - The ID of the issue type to add
 * @param issueType - The issue type data to store
 */
export function addIssueTypeToStore(
  store: RecordSourceProxy,
  issueTypeId: string,
  issueType: IssueTypePickerIssueType,
) {
  // Create an optimistic IssueType record with the provided fields so
  // issues can link to it immediately, as long as it does not yet exist.
  // If it does exist, still copy the values over, as they could be stale.
  const record = store.get(issueTypeId) || store.create(issueTypeId, 'IssueType')

  const propertiesToSet: IssueTypePickerIssueType = {
    id: issueTypeId,
    name: issueType.name,
    description: issueType.description,
    color: issueType.color,
    isEnabled: issueType.isEnabled,
  }

  for (const [key, value] of Object.entries(propertiesToSet)) {
    if (value != null) {
      record.setValue(value, key)
    }
  }
}
